import RootState from 'typings/RootState'
import { DashboardData, Filter } from './types'
import { Event } from 'features/types/event'

export const selectData = (state: RootState): DashboardData =>
  state.cmpjZoneDashboard.data
export const selectEvent = (state: RootState): Event =>
  state.cmpjZoneDashboard.event

export const selectSorting = (state: RootState) =>
  state.cmpjZoneDashboard.sorting

export const selectFilter = (state: RootState): Filter =>
  state.cmpjZoneDashboard.filter
